import type React from 'react';
import { Button } from '../atoms/button/button';
import KlarnaKIcon from '@tradera/blueprint/theme/icons-colored/klarna-k.svg?jsx';
import { classNames } from 'tradera/utils/class-names';
import styles from './social-buttons.module.scss';
import FacebookIcon from '@tradera/blueprint/theme/icons2/facebook.svg?jsx';
import AppleIcon from '@tradera/blueprint/theme/icons2/network-apple.svg?jsx';

export type SocialButtonProps = React.PropsWithChildren<{
    disabled?: boolean;
    loading?: boolean;
    className?: string;
    round?: boolean;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    tabIndex?: number;
}>;

export const KlarnaButton = ({
    round,
    className,
    children,
    ...props
}: SocialButtonProps) => {
    return (
        <Button
            fluid={!round}
            icon={<KlarnaKIcon />}
            fixedIcon={!round}
            theme="light"
            round={round}
            size={round ? 'md' : 'sm'}
            nonBrandedText
            className={classNames(className, styles.klarna, {
                [styles.round]: round
            })}
            {...props}>
            {children}
        </Button>
    );
};

export const FacebookButton = ({
    round,
    className,
    children,
    ...props
}: SocialButtonProps) => {
    return (
        <Button
            fluid={!round}
            icon={<FacebookIcon />}
            fixedIcon={!round}
            round={round}
            size={round ? 'md' : 'sm'}
            nonBrandedText
            className={classNames(className, styles.facebook, {
                [styles.round]: round
            })}
            {...props}>
            {children}
        </Button>
    );
};

export const AppleButton = ({
    round,
    className,
    children,
    ...props
}: SocialButtonProps) => {
    return (
        <Button
            theme="action"
            fluid={!round}
            icon={<AppleIcon />}
            fixedIcon={!round}
            round={round}
            size={round ? 'md' : 'sm'}
            nonBrandedText
            className={classNames(className, {
                [styles.round]: round
            })}
            {...props}>
            {children}
        </Button>
    );
};
